const state = {
  confirmar: {
    estado: false,
    msg: '',
    onConfirm: () => {}
  },
  fila: [],
  toaster: {
    open: false,
    timeout: 4000,
    color: '',
    message: ''
  },
  list: []
}

const mutations = {
  ADDLIST (state, item) {
    state.list.push(item)
  },
  ADDREF (state, { modal, ref }) {
    let i = state.list.findIndex(e => e.id === modal.id)
    if (i !== -1) state.list[i].ref = ref
  },
  OPEN (state, { modal, data }) {
    for (let x in state.list) {
      if (state.list[x].ativa) state.list[x].ativa = false
    }
    let i = state.list.findIndex(e => e.id === modal.id)
    if (i !== -1) {
      state.list[i].render = true
      state.list[i].ativa = true
      state.list[i].ref.refresh(data)
      state.fila.push(state.list[i].id)
    }
  },
  CLOSE (state, modal) {
    let i = state.list.findIndex(e => e.id === modal.id)
    if (i !== -1) {
      state.list[i].ativa = false
      state.fila.splice(-1, 1)
      let lastId = state.fila[state.fila.length - 1]
      if (lastId !== undefined && lastId !== null) {
        i = state.list.findIndex(e => e.id === lastId)
        state.list[i].render = true
        state.list[i].ativa = true
      }
    }
  },
  CLOSEALL (state) {
    state.fila = []
    for (let x in state.list) {
      state.list[x].onCancel()
      if (state.list[x].ativa) state.list[x].ativa = false
    }
  },
  DESTROY (state, modal) {
    let i = state.list.findIndex(e => e.id === modal.id)
    if (i !== -1) {
      let iFila = state.fila.findIndex(e => e === state.list[i].id)
      if (iFila !== -1) state.fila.splice(iFila, 1)
      state.list.splice(i, 1)
    }
  },
  ABRECONFIRMAR (state, { msg, onConfirm }) {
    state.confirmar.estado = true
    state.confirmar.msg = msg
    state.confirmar.onConfirm = onConfirm
  },
  FECHACONFIRMAR (state) {
    state.confirmar.estado = false
    state.confirmar.msg = ''
    state.confirmar.onConfirm = () => {}
  },
  ABRETOASTER (state, payload) {
    state.toaster.open = true
    state.toaster.timeout = payload.timeout || 4000
    state.toaster.color = payload.color || ''
    state.toaster.message = payload.message || ''
  }
}

const actions = {
  new ({ state, commit }, options) {
    let lastItem = state.list[state.list.length - 1]
    let all = {
      id: lastItem ? lastItem.id + 1 : 0,
      render: false,
      mode: options.mode || 'modal',
      component: options.component || '',
      ativa: options.ativa || false,
      width: options.width || 500,
      onCancel: options.onCancel || false,
      onSave: options.onSave || false,
      ref: null,
      data: {}
    }
    commit('ADDLIST', all)
    return all
  },
  async cancel ({ state, dispatch }, { modal, params }) {
    let i = state.list.findIndex(e => e.id === modal.id)
    if (i !== -1) {
      if (state.list[i].onCancel) await state.list[i].onCancel(...params)
      return dispatch('close', modal)
    }
  },
  async save ({ state, dispatch }, { modal, params }) {
    let i = state.list.findIndex(e => e.id === modal.id)
    if (i !== -1) {
      if (state.list[i].onSave) await state.list[i].onSave(...params)
      return dispatch('close', modal)
    }
  },
  addRef ({ commit }, { modal, ref }) {
    return commit('ADDREF', { modal, ref })
  },
  open ({ state, commit }, { modal, data }) {
    commit('OPEN', { modal, data })
  },
  close ({ state, commit }, modal) {
    commit('CLOSE', modal)
  },
  closeAll ({ commit }) {
    commit('CLOSEALL')
  },
  destroy ({ state, commit }, modal) {
    commit('DESTROY', modal)
  },
  confirmar ({ commit }, { msg, onConfirm }) {
    commit('ABRECONFIRMAR', { msg, onConfirm })
  },
  async okConfirmar ({ state, commit }) {
    await state.confirmar.onConfirm()
    commit('FECHACONFIRMAR')
  },
  closeConfirmar ({ state, commit }) {
    commit('FECHACONFIRMAR')
  },
  toaster ({ commit }, parametros) {
    commit('ABRETOASTER', parametros)
  }
}

export default { namespaced: true, state, mutations, actions }
